const commonTranslation = {
  hello: "Hallo",
  welcome: "Willkommen",
  english: "Englisch",
  german: "Deutsch",
  italian: "Italienisch",
  french: "Französisch",
  currentLanguage: "de-DE"
};

const loginComponent = {
  email: "E-Mail",
  emailAddress: "E-Mail Adresse",
  username: "Benutzername",
  password: "Passwort",
  login: "Anmelden",
  signUp: "Melden Sie sich an",
  multifactorAuthentication: "Mehrfaktorauthentifizierung",
  OTPCode: "OTP-Code",
  verifyAndProceed: "Verifizieren & Fortfahren",
  resendOTP: "OTP erneut senden",
  readMore: "Mehr Info",
  logout: "Abmelden",
  loginOrSignup: "Anmelden",
  loginWelcome: "Willkommen zurück! Bitte geben Sie Ihre Daten ein.",
  enterEmail: "Geben sie ihre E-Mail Adresse ein",
  enterPassword: "Passwort",
  getStarted: "Loslegen!",
  verificationRequired: "Verifizierung erforderlich",
  verificationDescription: "Geben Sie den Code ein, der in Ihrer Authentifizierungs-App angezeigt wird",
  loginRemember: "Erinnere dich 24 Stunden lang an mich",
  ForgotPassword: "Passwort vergessen",
  NoAccount: "Sie haben noch kein Konto?",
  loginAppInfo: "Ich habe keinen Zugriff auf meine Authenticator-App",
  loginSuccess: "Anmeldung erfolgreich",
  loginError: "Anmeldefehler",
};

const dashboardComponent = {
	gridView: "Rasteransicht",
	tableView: "Tabellenansicht",
	PDFExtraction: "Schadeneingang",
	search: "Suche",
	filter: "Filter",
	filters: "Filters",
	sortBy: "Sortieren",
	refresh: "Aktualisierung",
	sort: "Sortieren",
	sortFields: "Sortierfelder",
	edit: "Bearbeiten",
	download: "Herunterladen",
	versionHistory: "Verlauf",
	documentName: "Dokumentname",
	operator: "Bearbeiter",
	receiverName: "Empfängername",
	receiver: "Empfänger",
	extractedAt: "Extrahiert am",
	lastModified: "Zuletzt geändert",
	asc: "Auf",
	desc: "Ab",
	noOfPages: "Seitenanzahl",
	status: "Status",
	action: "Aktion",
	details: "Einzelheiten",
	medicine_info: "Informationen zu Arzneimitteln",
	generalInformation: "Allgemeine Informationen",
	invoice: "Rechnung",
	invoiceDate: "Rechnungsdatum",
	invoiceReference: "Rechnungsreferenz",
	vetName: "Tierarztname",
	vetStreet: "Tierarztstrasse",
	city: "Stadt",
	postalCode: "Postleitzahl",
	language: "Sprache",
	policyholderName: "Name des Versicherungsnehmers",
	policyholderAddress: "Straße des Versicherungsnehmers",
	treatment: "Behandlung",
	treatmentDate: "Behandlungsdatum",
	diagnosis: "Diagnose",
	itemName: "Artikelname",
	quantity: "Menge",
	prize: "Preis",
	VAT: "MwSt.",
	addTreatment: "Behandlung hinzufügen",
	addItem: "Artikel hinzufügen",
	total: "Gesamt",
	subTotal: "Zwischensumme",
	calculatedSum: "Gesamtsumme nach Rabatt",
	notes: "Notizen",
	page: "Seite",
	pages: "Seiten",
	min: " Min",
	mins: " Mins",
	hour: " Stunde",
	hours: " Stunden",
	day: " Tag",
	days: " Tagen",
	month: " Monat",
	months: " Monate",
	ago: "vor",
	modifiedBy: "Geändert von",
	modifiedAt: "Geändert am",
	clickASC: "Klicken, um aufsteigend zu sortieren",
	clickDESC: "Klicken, um absteigend zu sortieren",
	petName: "Haustiername",
	treatmentName: "Behandlungsname",
	items: "Artikel",
	InvoiceTotalSumPriceWithoutVAT: "Rechnungsgesamtbetrag ohne Mehrwertsteuer",
	InvoiceTotalSumPriceWithVAT: "Rechnungsgesamtbetrag mit Mehrwertsteuer",
	CalculatedTotalSum: "Berechnete Gesamtsumme",
	TotalDiscountAmount: "Gesamtrabattbetrag",
	CalculatedTotalSumAfterDiscount: "Berechnete Gesamtsumme nach Rabatt",
	recent: "Jüngste",
	viewHistory: "Siehe Verlauf",
	remember: "Fragen Sie heute nicht noch einmal",
	assignment_confirmation: "Auftragsbestätigung",
	revoke_confirmation: "Bestätigung widerrufen",
	rememberSentance:
		"Wir werden Sie heute nicht mehr nach einem Bestätigungscode auf Ihrem vertrauenswürdigen Gerät fragen, wenn Sie sich anmelden.",
	Complete_login: "Anmeldung abschliessen",
	date: "Datum",
	time: "Zeit",
	note: "Notiz",
	comment: "Kommentare",
	profile: "Profil",
	no_content: "Kein Inhalt",
	revoke: "Widerrufen",
	deleteTreatment: "Behandlung löschen",
	deleteItem: "Element löschen",
	lastUpdate: "Letztes Update",
	board: "Kacheln",
	table: "Liste",
	modified: "Angepasst von",
	showing: "zeigen",
	totalSum: "Gesamtsumme",
	of: "von",
	none: "Keine",
	customVAT: "MwSt eingeben",
	quality_level: "Qualitätsstufe",
	good: "Gut",
	verify: "Überprüfen",
	not_extracted: "Nicht Extrahiert",
	"Missing Data": "Fehlende Daten",
	apply: "Anwenden",
	copy: "Kopieren",
	moveToPage: "Zu Seite verschieben",
	clearSelection: "Auswahl löschen",
	pasteItem: "Einfügen Hier",
};

const commonEvents = {
  add: "Hinzufügen",
  update: "Aktualisieren",
  save: "Speichern",
  cancel: "Abbrechen",
  reset: "Zurücksetzen",
  download: "Herunterladen",
  clear: "Entfernen",
  delete: "Löschen",
  assign: "Zuweisen",
  resetInitial: "Auf Anfang zurücksetzen",
  back: "Zurück",
  assignment_confirmation: "Auftragsbestätigung",
  enter_notes: "Geben Sie hier Ihre Notizen ein...",
  Updated : "Aktualisiert",
  Exported : "Exportiert",
  Revoked: "Widerrufen",
  Assigned: "Zugewiesen",
  medicineDescription: "Beschreibung",
  purpose: "Zweck",
  usedFor: "Verwendung",
  petTypes: "Tierarten",
  activeIngredients: "Aktive Inhaltsstoffe",
  category: "Kategorie",
  typeOfDamage: "Art des Schadens",
  causeOfDamage: "Schadensursache",
  loading: "Laden..."
};

const documentStatus = {
  not_yet_started: "Nicht begonnen",
  in_progress: "In Bearbeitung",
  completed: "Abgeschlossen",
};

const confirmationMessages = {
  deleteConfirmationTitle: "Bestätigung",
  deleteActionTreatmentContent:
    "Sind Sie sicher, dass Sie diese Behandlung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden",
  deleteActionItemContent:
    "Sind Sie sicher, dass Sie diese Position löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden",
  resetConfirmationTitle: "Bestätigung",
  resetToInitialConfirmationTitle: "Zurücksetzen auf Erstbestätigung",
  resetActionContent:
    "Sind Sie sicher, dass Sie einen Reset durchführen möchten? Diese Aktion kann nicht rückgängig gemacht werden",
  resetInitialActionContent:
    "Sind Sie sicher, dass Sie auf den Anfangszustand zurücksetzen möchten? Diese Aktion kann nicht rückgängig gemacht werden",
  assignmentConfirmation:
    "Sind Sie sicher, dass Sie dieses Dokument sich selbst zuweisen möchten?",
  revokeConfirmation: "Sind Sie sicher, dass Sie die Zuweisung dieses Dokuments zu Ihrer Person aufheben möchten?",
  reAssignConfirmation:
    "Sind Sie sicher, dass Sie dieses Dokument erneut sich selbst zuweisen möchten?",
  assignedTo: "Dieses Dokument ist zugewiesen an",
};

const errorNotification = {
  invalidEmail: "Bitte geben Sie eine gültige E-Mail Adresse ein!",
  emailEmpty: "Bitte geben Sie Ihre E-Mail Adresse ein!",
  passwordEmpty: "Bitte geben Sie Ihr Passwort ein!",
  notAllowedToEdit: "Dieses Dokument darf nicht bearbeitet werden",
  noteNotSaved: "Notizen werden nicht gespeichert",
  tokenExpired: "Ihre Sitzung ist abgelaufen, bitte melden Sie sich an",
  accessDenied: "Zugriff verweigert",
  notAssigned: "Bitte weisen Sie sich das Dokument zu, um Zugriff zu erhalten",
};

const successNotification = {
  DocumentResetToInitial: 'Erfolgreich auf Anfang zurückgesetzt',
  UpdateSuccess: "Erfolgreich geupdated",
  noteSaved: "Notizen wurden erfolgreich gespeichert",
  successDocumentProgressStatus: "Zuweisung erfolgt",
  revokeDocument: "Zuweisung aufgehoben",
}
export let deJSON = {
  ...commonEvents,
  ...loginComponent,
  ...dashboardComponent,
  ...errorNotification,
  ...commonTranslation,
  ...documentStatus,
  ...confirmationMessages,
  ...successNotification
};
